function RightBarHero(){
    
    return(
        <div className="right-bar-hero">
            <div className="right-bar-hero-content">
                <img className="blob-svg" src="/images/blob.svg" alt="blob"/>
                <img className="hero-img" src="/images/hero-img.png" alt="Happy Teachers"/>
            </div>
        </div>
    );
}
export default RightBarHero;